import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { assetUrl } from 'src/app/globals/globals';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  assetUrl = assetUrl;
  showModal: boolean = false;
  termsAndConditions: any[] = [];
  termsUrl = `${environment.API_URL}/TermsAndConditions`;

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.loadTermsAndConditions();
  }

  loadTermsAndConditions() {
    this.http.get<any[]>(this.termsUrl).subscribe(data => {
      this.termsAndConditions = data;
      this.sortTermsByOrder();
    });
  }

  sortTermsByOrder() {
    this.termsAndConditions.sort((a, b) => {
      return a.orden - b.orden;
    });
  }
}